import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { AccountTypeEnum } from "@api";
import { usePurgeAccount } from "@api/v1/hooks/useAccounts";
import { Banner, ConfirmDeleteDialog } from "@components";

const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

interface AccountEditPageActionsProps {
  accountId: string;
  accountType?: AccountTypeEnum;
}

export const AccountEditActions = (props: AccountEditPageActionsProps) => {
  const { accountType, accountId } = props;
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const {
    mutate,
    isPending,
    isError,
    error,
    reset: mutationReset,
  } = usePurgeAccount({
    onSuccess: () => {
      handleCloseDialog();
    },
  });

  let title = "";
  let modalTitle = "";
  let modalBody = "";

  switch (accountType) {
    case "01_depot":
      title = t("createAndEditAccount.actions.deleteAllInvestments");
      modalTitle = t("createAndEditAccount.deleteDialog.titleInvestments");
      modalBody = t("createAndEditAccount.deleteDialog.questionInvestments");
      break;
    case "02_cash":
      title = t("createAndEditAccount.actions.deleteAllCashTransactions");
      modalTitle = t(
        "createAndEditAccount.deleteDialog.titleAllCashTransactions"
      );
      modalBody = t(
        "createAndEditAccount.deleteDialog.questionCashTransaction"
      );
      break;
    default:
      return null;
  }

  const handleDeleteClick = () => {
    mutate(accountId);
    mutationReset();
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <Container>
      <Banner
        type="warn"
        text={title}
        primaryButton={{
          label: t("createAndEditAccount.actions.delete"),
          onClick: handleOpenDialog,
          testId: "delete-all-button",
        }}
      />

      <ConfirmDeleteDialog
        confirmButtonText={t("createAndEditAccount.deleteDialog.delete")}
        cancelButtonText={t("createAndEditAccount.deleteDialog.close")}
        isOpen={dialogOpen}
        onClose={handleCloseDialog}
        onDelete={handleDeleteClick}
        text={modalBody}
        isDeleteRequestLoading={isPending}
        title={modalTitle}
        errorMessage={isError ? error?.response?.data?.message : undefined}
        testId="delete-confirmation-dialog"
      />
    </Container>
  );
};
